import { Form, Input, Select } from 'antd';
import { postApi, putApi } from 'apis';
import Buttons from 'components/Global/Buttons';
import { FC, useState } from 'react';
import { monthOptions, toastText } from 'utils/utils';
import styles from './index.module.scss';
import { SideDrawerBodyProps } from './types';

const AddBranchCodeBody: FC<SideDrawerBodyProps> = (props) => {
	const [loading, setLoading] = useState<boolean>(false);
	const {
		closeDrawerByAnimation,
		fetchBranchCodes,
		editSelected,
		calculationMethod,
	} = props;

	const buttons = [
		{
			text: `Cancel`,
			isLoading: false,
			className: 'btn-cancel',
			isSubmit: true,
			disabled: loading,
			onclick: () => {
				closeDrawerByAnimation();
			},
			fontSize: '1.8rem',
			minWidth: '12rem',
			minHeight: '4rem',
		},
		{
			text: 'Save',
			isLoading: loading,
			className: 'btn-blue',
			isSubmit: true,
			disabled: false,
			fontSize: '1.8rem',
			minWidth: '12rem',
			minHeight: '4rem',
			onclick: () => {},
		},
	];

	const handleSubmit = async (values: any) => {
		if (editSelected) {
			let data: any = {
				branchCodeId: editSelected?.id,
				...values,
			};

			await updateBranchCode(data);
		} else {
			await addBranchCode(values);
		}
	};

	const updateBranchCode = async (categoryCodeData: any) => {
		try {
			setLoading(true);
			const response = await putApi('/branchCode', categoryCodeData);
			let message =
				response?.data?.message || 'Branch code updated successfully';
			toastText(message, 'success');
			fetchBranchCodes();
			closeDrawerByAnimation();
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong in updating branch code';
			toastText(errorMessage, 'error');
		} finally {
			setLoading(false);
		}
	};
	const addBranchCode = async (finalData: any) => {
		try {
			setLoading(true);

			const response = await postApi('/branchCode', finalData);
			let message =
				response?.data?.message || 'Branch code created successfully';
			fetchBranchCodes();
			closeDrawerByAnimation();
			toastText(message, 'success');
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong when creating to branch code';
			toastText(errorMessage, 'error');
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<p className={styles['form-container-head-warning']}>
				<b>
					{' '}
					<sup>*</sup>
				</b>{' '}
				Indicated mandatory fields
			</p>
			<div className={styles['side-drawer-body']}>
				<Form
					name="basic"
					className={styles['side-drawer-form']}
					labelCol={{ span: 8 }}
					wrapperCol={{ span: 16 }}
					style={{ maxWidth: 600 }}
					onFinish={handleSubmit}
					initialValues={editSelected}
					autoComplete="off"
				>
					<div className={styles['side-drawer-form__inputs']}>
						<label
							className={styles['side-drawer-form__role--label']}
						>
							{'Branch Code'}{' '}
							<span className="required-color">*</span>
						</label>
						<Form.Item
							// className="side-drawer-form__role"
							name={'code'}
							rules={[
								{
									required: true,
									message: 'Please enter the Branch Code',
									validateTrigger: 'onChange',
									validator: (_, value) =>
										value && value.trim() !== ''
											? Promise.resolve()
											: Promise.reject(
													new Error(
														'Branch code cannot be empty'
													)
											  ),
								},
							]}
							wrapperCol={{ span: 24 }}
						>
							<Input
								className="remove-antd-input-effect"
								maxLength={150}
								size="large"
								disabled={false}
								type={'text'}
							/>
						</Form.Item>
					</div>
					<div className={styles['side-drawer-form__inputs']}>
						<label
							className={styles['side-drawer-form__role--label']}
						>
							{'Branch Name'}{' '}
							<span className="required-color">*</span>
						</label>
						<Form.Item
							// className="side-drawer-form__role"
							name={'name'}
							rules={[
								{
									required: true,
									message: 'Please enter the Branch Name',
									validateTrigger: 'onChange',
									validator: (_, value) =>
										value && value.trim() !== ''
											? Promise.resolve()
											: Promise.reject(
													new Error(
														'Please enter value'
													)
											  ),
								},
							]}
							wrapperCol={{ span: 24 }}
						>
							<Input
								className="remove-antd-input-effect"
								maxLength={150}
								size="large"
								disabled={false}
								type={'text'}
							/>
						</Form.Item>
					</div>
					<div className={styles['side-drawer-form__inputs']}>
						<label
							className={styles['side-drawer-form__role--label']}
						>
							{'Branch Address'}{' '}
						</label>
						<Form.Item
							name={'address'}
							rules={[
								{
									message: 'Please enter your branch address',
									validateTrigger: 'onChange',
								},
							]}
							wrapperCol={{ span: 24 }}
						>
							<textarea
								className={styles['side-drawer-form--textarea']}
							/>
						</Form.Item>
					</div>

					<div className={styles['side-drawer-form__inputs']}>
						<label
							className={styles['side-drawer-form__role--label']}
						>
							{'Branch City'}{' '}
							<span className="required-color">*</span>
						</label>
						<Form.Item
							// className="side-drawer-form__role"
							name={'city'}
							rules={[
								{
									required: true,
									message:
										'Please enter the City of the Branch',
									validateTrigger: 'onChange',
									validator: (_, value) =>
										value && value.trim() !== ''
											? Promise.resolve()
											: Promise.reject(
													new Error(
														'Please enter value'
													)
											  ),
								},
								// {
								// 	max: 30,
								// 	message:
								// 		'Branch city length must be less than 30 characters',
								// 	validateTrigger: 'onChange',
								// },
							]}
							wrapperCol={{ span: 24 }}
						>
							<Input
								className="remove-antd-input-effect"
								maxLength={150}
								size="large"
								disabled={false}
								type={'text'}
								// defaultValue={
								// 	userProfileData[item?.name]
								// }
							/>
						</Form.Item>
					</div>
					{calculationMethod === 'BRANCH_WISE' && (
						<div className={styles['side-drawer-form__inputs']}>
							<label
								className={
									styles['side-drawer-form__role--label']
								}
							>
								{'Gratuity and Leave Pay Calculation Month'}{' '}
								<span className="required-color">*</span>
							</label>
							<Form.Item
								name={'calculationMonth'}
								rules={[
									{
										required: true,
										message:
											'Please select the calculation month',
									},
								]}
								wrapperCol={{ span: 24 }}
								help="Select the month when both gratuity pay and leave pay should be calculated for this branch"
							>
								<Select
									size="large"
									options={monthOptions}
									placeholder="Select month"
									disabled={
										editSelected?.calculationMonth &&
										editSelected?.isPayrollRun
									}
								/>
							</Form.Item>
						</div>
					)}

					<div className={styles['side-drawer-form__buttons']}>
						<Form.Item>
							<Buttons buttons={buttons} />
						</Form.Item>
					</div>
				</Form>
			</div>
		</>
	);
};

export default AddBranchCodeBody;
